import walletFinancialPositionsMessages from '../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../column';
import { WelfareProduct } from '../welfare-macro-category';

export const welfareColumns: Column<WelfareProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
    key: 'newContractCode',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderDate,
    key: 'date',
    type: 'date',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValue,
    key: 'equivalent',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderItemsInTransit,
    key: 'itemsInTransit',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderBalancePosition,
    key: 'balancePosition',
    type: 'amount',
  },
];
